/* eslint-disable */
import $ from 'jquery';
import { DataLayer_cart } from './DataLayer_cart';
import { DataLayer_events_form } from './DataLayer_events_form';
let page_path;
let trigger_datalayer_cart = false;
let get_datalayer;
let user_email;

new DataLayer_events_form;
/**
 * Cart datalayer
 */
$('.subscription-options a.1')
  .on('click', function (e) {
    const current_selector = $(this);
    const datalayer_cart_attr = {};
    datalayer_cart_attr.event = 'add_to_cart';
    datalayer_cart_attr.item_id = current_selector.attr('data-prod-id');
    datalayer_cart_attr.item_quantity = 1;
    new DataLayer_cart( datalayer_cart_attr );
  });

/**
 * Payment datalayers
 */
// Create a new datalayer when the user click the button to pay
$('#place_order')
  .on('click', function () {
    // Prepare the data for the add_payment_info datalayer
    const datalayer_cart_attr = {};
    datalayer_cart_attr.origin = 'payment';
    datalayer_cart_attr.event = 'add_payment_info';
    datalayer_cart_attr.items_object = JSON.parse(window.localStorage.getItem('items_object_key'));
    datalayer_cart_attr.cart_total_value = window.localStorage.getItem('cart_total_value_key');
    user_email = $('#billing_email').val();
    window.localStorage.setItem('user_email_key', user_email); // Store the user email in a session variable
    new DataLayer_cart( datalayer_cart_attr );
  });

$(window)
  .on('load',function() {
    page_path = window.location.href; // Get the current url
    /**
     * Purchase datalayer
     */
    // Create a new datalayer when payment was accepted and returns to the 'thank you' page
    if ( page_path.indexOf('/checkout/order-received/') >= 0 ) {
      // Prepare the data for the purchase datalayer
      const datalayer_cart_attr = {};
      datalayer_cart_attr.origin = 'payment';
      datalayer_cart_attr.event = 'purchase';
      datalayer_cart_attr.items_object = JSON.parse(window.localStorage.getItem('items_object_key'));
      const url_split = page_path.split('/');
      datalayer_cart_attr.transaction_id = url_split[5];
      datalayer_cart_attr.cart_total_value = JSON.parse(window.localStorage.getItem('cart_total_value_key'));
      datalayer_cart_attr.user_email = window.localStorage.getItem('user_email_key');
      new DataLayer_cart( datalayer_cart_attr );
    }
  });
